export const NoViewsPage = () => {
	return <></>;
};
